const usersGroupeReducer = (state = [], action) => {
  switch (action.type) {
    case 'USERSGROUP':
      return action.data
    default:
      return state
  }
}

export default usersGroupeReducer
